import PageLayout from '@/components/feature/PageLayout';
import CasesHero from '@/pages/cases/components/CasesHero';
import CasesGrid from '@/pages/cases/components/CasesGrid';

export default function CasesPage() {
  return (
    <PageLayout>
      <CasesHero />
      <CasesGrid />
    </PageLayout>
  );
}